// Pricing Details - Comparação detalhada dos planos
import { pricingPlans } from '../data/pricingPlans';
import { cn } from '../../../utils/cn';
import { Check, Users, Database, Cloud, ArrowDownCircle } from 'lucide-react';

export function PricingDetails() {
  return (
    <section id="pricing-details" className="py-20 bg-gray-50 dark:bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={cn(
                'rounded-xl p-6 border-2 transition-all duration-300',
                plan.highlighted
                  ? 'bg-green-800 text-white border-green-800 shadow-2xl'
                  : 'bg-white dark:bg-gray-900 text-gray-900 dark:text-white border-gray-200 dark:border-gray-800 hover:shadow-lg'
              )}
            >
              {/* Header */}
              <div
                className={cn(
                  'mb-6 pb-4 border-b-2',
                  plan.highlighted ? 'border-green-700' : 'border-gray-200 dark:border-gray-700'
                )}
              >
                <button
                  className={cn(
                    'w-full py-2 px-4 rounded-lg font-medium mb-4',
                    plan.ctaType === 'free'
                      ? plan.highlighted
                        ? 'bg-green-700 hover:bg-green-600 text-white'
                        : 'bg-green-600 hover:bg-green-700 text-white'
                      : plan.highlighted
                        ? 'bg-green-700 hover:bg-green-600 text-white'
                        : 'bg-green-700 hover:bg-green-800 text-white'
                  )}
                >
                  {plan.ctaType === 'free' ? 'Comece grátis' : 'Fale com vendas'}
                </button>
              </div>

              {/* Métricas */}
              <div className="space-y-4 mb-6">
                <div className="flex items-center gap-3">
                  <Users className={cn('w-5 h-5', plan.highlighted ? 'text-green-300' : 'text-green-600')} />
                  <span className={cn('text-sm', plan.highlighted ? 'text-green-100' : 'text-gray-700 dark:text-gray-300')}>
                    {plan.users} usuários
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Database className={cn('w-5 h-5', plan.highlighted ? 'text-green-300' : 'text-green-600')} />
                  <span className={cn('text-sm', plan.highlighted ? 'text-green-100' : 'text-gray-700 dark:text-gray-300')}>
                    {plan.dataStorage} de dados
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Cloud className={cn('w-5 h-5', plan.highlighted ? 'text-green-300' : 'text-green-600')} />
                  <span className={cn('text-sm', plan.highlighted ? 'text-green-100' : 'text-gray-700 dark:text-gray-300')}>
                    {plan.fileStorage} de arquivos
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <ArrowDownCircle className={cn('w-5 h-5', plan.highlighted ? 'text-green-300' : 'text-green-600')} />
                  <span className={cn('text-sm', plan.highlighted ? 'text-green-100' : 'text-gray-700 dark:text-gray-300')}>
                    {plan.marketplaceImports} importações de pedidos em marketplaces por mês
                  </span>
                </div>
              </div>

              {/* Features */}
              <div className="space-y-3">
                <h4 className={cn('font-semibold mb-3', plan.highlighted ? 'text-green-100' : 'text-gray-900 dark:text-white')}>
                  Recursos incluídos:
                </h4>
                {plan.features.map((feature, index) => (
                  <div key={index} className="flex items-start gap-2">
                    <Check className={cn('w-5 h-5 flex-shrink-0 mt-0.5', plan.highlighted ? 'text-green-300' : 'text-green-600')} />
                    <span className={cn('text-sm', plan.highlighted ? 'text-green-100' : 'text-gray-700 dark:text-gray-300')}>
                      {feature}
                    </span>
                  </div>
                ))}
              </div>

              {/* Link Comparar */}
              <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700">
                <button
                  className={cn(
                    'text-sm underline w-full text-left',
                    plan.highlighted ? 'text-green-300 hover:text-green-200' : 'text-green-600 hover:text-green-700'
                  )}
                >
                  Compare os planos
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
